import { configureStore, Middleware } from '@reduxjs/toolkit';
import authSlice from './slices/auth';
import onboardingSlice from './slices/onboarding';
import dashboardSlice from './slices/dashboard';
import voiceToSpeechSlice from './slices/v-t-s';
import accessibility from './slices/floating-icons-state';
import posthogSlice from './slices/posthog';
import { markLastActivity } from '@/shared/helpers/lastActivity';

// seeds the last-activity timestamp whenever auth.login.token transitions from empty to set,
// regardless of which action set it (setToken, login, confirmCode, ...)
const activityTrackingMiddleware: Middleware = storeApi => next => action => {
    const prevToken = storeApi.getState().auth.login.token;
    const result = next(action);
    if (!prevToken && storeApi.getState().auth.login.token) {
        markLastActivity();
    }
    return result;
};
import chatState from './slices/chat-state';

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        onboarding: onboardingSlice.reducer,
        dashboard: dashboardSlice.reducer,
        voiceToSpeech: voiceToSpeechSlice.reducer,
        accessibility: accessibility.reducer,
        chatState: chatState.reducer,
        posthog: posthogSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(activityTrackingMiddleware)
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
